// import BrowserHelper from "@/_helpers/browser/browser-helper";
// let browserHelper = new BrowserHelper();

import { mapGetters } from "vuex";
import { SalesOrderTypeService } from "../_services/api/sales/sales-order-type.service";
import { getDecimalFormat, getGlobalField } from "../_store/helpers";
import { GridReportService } from "../_services/api/reports/grid-report.service"
import Form from "devextreme/ui/form";

export default {
    props: {},
    data() {
        return {
            // isTablet: false,
            formsConfig: {

                labelPosition: "left",
                loadingVisible: false,
                formMode: undefined,
                validationSummaryVisible: false,
                serverValidationSummaryVisible: false,
                customValidationSummaryVisible: false,
                validationWarningVisible: false,

                warningTitle: undefined,

                items: [],
                serverItems: [],
                warningItems: [],
            },
            validatingForm: false,

            orderComments: {
                dataField: "SalesOrderTypeCode",
                endpoint: "SalesOrderType",
                toMatch: [
                    "UserComment1",
                    "UserComment2",
                    "UserComment3",
                    "UserComment4",
                    "UserComment5",
                    "UserComment6",
                    "UserComment7",
                    "UserComment8",
                    "UserComment9",
                    "UserComment10",
                    "UserComment11",
                    "UserComment12",
                    "UserComment13",
                    "UserComment14",
                    "UserComment15",
                    "UserComment16",
                    "UserComment17",
                    "UserComment18",
                    "UserComment19",
                    "UserComment20",
                ],
            },
            commentItems: [
                {
                    itemType: "group",
                    caption: "",
                    items: [],
                },
            ],

        };
    },
    watch: {
    },
    computed: {
        ...mapGetters({ getVisibleCommentLabels: "ui/getVisibleCommentLabels" }),
        pageKey() {
            return this.baseView.mode + this.key;
        },
    },
    async created() {
        // this.isTablet = this.baseView.query.t
        //     ? true
        //     : browserHelper.tablet
        //         ? true
        //         : false;
    },
    methods: {
        showLoading(show) {
            this.formsConfig.loadingVisible = show;
        },

        customizeItem(item) {
            // console.log('customizeItem ', this.formsConfig.formMode, " ", item);
            if (item.itemType == "simple") {
                item.editorOptions = item.editorOptions || {};

                item.editorOptions.disabled = this.formsConfig.formMode != "review" ? false : true;
                if (item.editorOptions.allowUpdate == false) item.editorOptions.disabled = true;
                if (item.editorOptions.allowUpdate == true) item.editorOptions.disabled = false;
                if (item.editorOptions.readOnly) item.editorOptions.readOnly = true;
            }
        },
        addToValidationItems(message) {
            this.displayValidationSummary([
                {
                    message: message,
                },
            ]);
        },

        displayValidationSummary(itemArray) {
            this.formsConfig.validationSummaryVisible = false;

            this.formsConfig.items = [];
            if (itemArray)
                itemArray.forEach((x) => {
                    this.formsConfig.items.push(x.message);
                });
            this.formsConfig.validationSummaryVisible = true;
        },

        displayValidationErrors(itemArray) {
            this.formsConfig.items = [];
            if (itemArray) {
                this.formsConfig.items = itemArray;
            }
            this.formsConfig.validationSummaryVisible = true;
        },

        displayWarningSummary(itemArray) {
            this.formsConfig.warningItems = [];
            this.formsConfig.warningTitle = undefined;
            if (itemArray)
                itemArray.forEach((x) => {
                    this.formsConfig.warningItems.push(x.message);
                    if (x.title) this.formsConfig.warningTitle = x.title;
                });
            this.formsConfig.validationWarningVisible = true;
        },

        async setOrderComments(SalesOrderTypeCode) {

            this.commentItems = [
                {
                    itemType: "group",
                    caption: "",
                    items: [],
                },
            ];
            this.$store.dispatch(
                "ui/setCommentPopUpItems",
                this.commentItems
            );


            if (this.orderComments) {
                await SalesOrderTypeService.getByCode(
                    SalesOrderTypeCode
                )
                    .then((soType) => {
                        var commentConfig = soType.data.value[0];

                        if (commentConfig) {
                            this.orderComments.toMatch.forEach(
                                (element, i) => {
                                    var item = {
                                        dataField: element,
                                        label: {
                                            text: commentConfig["CommentLabel" + (i + 1)],
                                            visible: this.getVisibleCommentLabels
                                        },
                                        editorType: "dxTextBox",
                                        editorOptions: {
                                            maxLength: 100,
                                            placeholder: !this.getVisibleCommentLabels ? commentConfig["CommentLabel" + (i + 1)] : undefined
                                        },
                                        visible: commentConfig["CommentLabel" + (i + 1)] != "",
                                        validationRules:
                                            commentConfig["CommentRequired" + (i + 1)] == "Y"
                                                ? [
                                                    {
                                                        type: "required",
                                                        message: `${commentConfig["CommentLabel" + (i + 1)]
                                                            } is required`,
                                                        validationMessageMode: "always",
                                                    },
                                                ]
                                                : [],
                                    };

                                    this.commentItems[0].items.push(
                                        item
                                    );
                                }
                            );
                            this.$store.dispatch(
                                "ui/setCommentPopUpItems",
                                this.commentItems
                            );
                        }


                        // this.showLoading(false);
                    })
                    .catch((err) => {
                        // this.showLoading(false); 
                        this.$logger.debug("getSoType err ", err);
                    });
            }
            // this.showLoading(false); 

        },
        parseFormItems(formItems) {
            var items = [];
            if (!formItems) return items;
            formItems.forEach((element) => {
                if (element.items && element.items.length > 0)
                    this.formItemLoop(element.items);
                else this.getGlobal(element);
            });

            return formItems;
        },

        formItemLoop(items) {
            if (items[0].itemType != "group") {
                this.setGlobal(items);
            } else {
                items.forEach((element) => {
                    if (element.items && element.items.length > 0)
                        this.formItemLoop(element.items);
                });
            }
        },
        setGlobal(items) {
            return items
                .map((c) => {
                    if (c.itemType != "group") {
                        c.isNormal = this.isNormal;
                        this.getGlobal(c);
                    } else {
                        this.setGlobal(c.items);
                    }
                })
                .filter((x) => x != null);
        },
        getGlobal(c) {
            let globalField = { ...getGlobalField(c.screenField) };

            if (Object.keys(globalField).length > 0) {
                let fieldData = globalField.formField
                    ? globalField.formField
                    : globalField;

                c.dataField = c.dataField ? c.dataField : fieldData.dataField;
                c.label = c.label
                    ? c.label
                    : {
                        text: fieldData.label,
                        visible: c.labelVisible ? false : true,
                    };
                if (!c.editorOptions) c.editorOptions = {};
                if (!c.editorOptions["maxLength"] && fieldData.maxLength)
                    c.editorOptions["maxLength"] = fieldData.maxLength;

                if (fieldData.type == "switch") c.editorType = "dxSwitch";
                if (fieldData.type == "Date") {
                    c.editorType = "dxDateBox";
                    c.editorOptions.displayFormat = "dd MMM yyyy";
                }
                if (fieldData.type == "Decimal" || fieldData.type == "Number")
                    c.editorType = "dxNumberBox";
                if (fieldData.type == "CheckBox" || fieldData.type == "Boolean")
                    c.editorType = "dxCheckBox";
                if (c.type == "Decimal" || c.type == "Number")
                    c.editorType = "dxNumberBox";

                if (c.dataSourceConfig) {
                    globalField.dataSourceConfig = c.dataSourceConfig;
                }

                if (c.valueExpr) {
                    globalField.valueExpr = c.valueExpr;
                }
                if (c.displayExpr) {
                    globalField.displayExpr = c.displayExpr;
                }

                if (c.editorTemplate) {
                    globalField.editorTemplate = c.editorTemplate;
                }

                // if (c.required) {
                //   // c.editorOptions["validationMessageMode"] = "always";
                //   c.validationRules = [
                //     {
                //       type: "required",
                //       message: `${c.label.text} is required`,
                //     },
                //   ];
                // }

                if (this.baseView.mode == "review" && !c.editorOptions.allowUpdate)
                    c.required = false;

                if (c.allowUpdate == false) {
                    if (this.baseView.mode != "review")
                        c.editorOptions["readOnly"] = true;
                    else c.editorOptions["readOnly"] = false;
                }

                if (c.editAddress) this.deliveryLabel = "Edit";

                if (
                    fieldData.cellTemplate &&
                    c.allowUpdate != false &&
                    !c.editorOptions["itemTemplate"]
                ) {
                    c.template = fieldData.cellTemplate;
                }
                if (fieldData.format)
                    c.editorOptions["format"] = this.getDecimalFormatFromHelper(
                        fieldData.format
                    );

                // if (c.screenField == "Branch") {
                // primary key fields should not have a datsouurce to be selected from
                if (!c.isPrimaryKeyField && c.allowUpdate != false) {
                    if (globalField.dataSourceConfig) {
                        // console.log("<<<<<<<<<<<<<  ", c, " ", globalField);
                        let filter = [];

                        if (globalField.dataSourceConfig.filter)
                            filter.push(globalField.dataSourceConfig.filter);
                        if (c.filter)
                            if (!filter) filter = c.filter;
                            else {
                                if (filter.length > 0)
                                    filter.push("and");
                                filter.push(c.filter);
                            }

                        c.editorType = "dxSelectBox";

                        if (globalField.dataSourceConfig.data) {
                            globalField.dataSourceConfig.data.forEach((element) => {
                                element.screenField = c.screenField;
                                element.cellTemplateRecord = c.cellTemplateRecord
                                    ? c.cellTemplateRecord
                                    : globalField.cellTemplateRecord;
                            });
                            c.editorOptions.items = globalField.dataSourceConfig.data;
                        } else
                            c.editorOptions.dataSource = GridReportService.dataSourceConfig(
                                globalField.dataSourceConfig.endpoint,
                                {
                                    filter: filter.length != 0 ? filter : undefined,
                                    select: globalField.dataSourceConfig.select,
                                    sort: globalField.dataSourceConfig.sort,
                                    postProcess: (data) => {
                                        data.forEach((element) => {
                                            if (c.screenField) element.screenField = c.screenField;
                                            element.cellTemplateRecord = c.cellTemplateRecord
                                                ? c.cellTemplateRecord
                                                : globalField.cellTemplateRecord;
                                        });

                                        return data;
                                    },
                                }
                            );

                        c.editorOptions.valueExpr = globalField.valueExpr;
                        c.editorOptions.displayExpr = globalField.displayExpr;
                        c.editorOptions.searchExpr = c.searchExpr
                            ? c.searchExpr
                            : [globalField.valueExpr, globalField.displayExpr];
                        c.editorOptions.searchMode = "contains";
                        c.editorOptions.searchEnabled = true;
                        if (globalField.editorTemplate || c.editorTemplate)
                            c.editorOptions.itemTemplate = c.itemTemplate
                                ? c.itemTemplate
                                : globalField.itemTemplate
                                    ? globalField.itemTemplate
                                    : "item-template";
                        if (c.defaultValue) c.editorOptions.value = c.defaultValue;
                        c.template = undefined;

                        // c.cellTemplateRecord = globalField.cellTemplateRecord;

                        if (c.onValueChange)
                            c.editorOptions.onValueChanged = c.onValueChange;

                        if (c.onItemClick)
                            c.editorOptions.onItemClick = c.onItemClick.bind(
                                this,
                                this.formModel
                            );

                        if (c.acceptCustomValue)
                            c.editorOptions.acceptCustomValue = c.acceptCustomValue;
                        if (c.onCustomItemCreating)
                            c.editorOptions.onCustomItemCreating = c.onCustomItemCreating;

                        if (c.ref) c.editorOptions.ref = c.ref;
                    }
                }

                if (c.displayExpr) {
                    globalField.displayExpr = c.displayExpr;
                }
                // }

                if (c.validationRules && c.required) {
                    c.validationRules.push({
                        type: "required",
                        message: `${c.label.text} is required`,
                        validationMessageMode: "always",
                    });
                } else if (c.required) {
                    c.validationRules = [
                        {
                            type: "required",
                            message: `${c.label.text} is required`,
                            validationMessageMode: "always",
                        },
                    ];
                    // c.editorOptions.validationMessageMode = "always";
                }

                let onFocusIn = undefined;
                if (c.editorOptions.onFocusIn) onFocusIn = c.editorOptions.onFocusIn;
                c.editorOptions.onFocusIn = (e) => {
                    if (e && e.element) {
                        var input = e.element.querySelector("input");
                        if (input)
                            input.setAttribute(
                                "autocomplete",
                                "new-input-" + e.name ? e.name : new Date().getTime()
                            );
                    }

                    if (onFocusIn) {
                        onFocusIn(e);
                    }
                };

                // console.log("A # ", c);
                return c;
            } else {
                // eslint-disable-next-line
                console.log(
                    "%c GlobalField Not Found :",
                    "background: #222; color: #da8655",
                    c.screenField ? c.screenField : c.dataField
                );

                if (!c.editorOptions) c.editorOptions = {};

                if (c.allowUpdate == false) {
                    c.editorOptions["readOnly"] = true;
                }
                if (c.itemType != "group")
                    c.dataField = c.dataField ? c.dataField : c.screenField;

                if (
                    c.editorOptions.format != undefined &&
                    !c.editorOptions.customFormat
                ) {
                    c.editorOptions["format"] = this.getDecimalFormatFromHelper(
                        c.editorOptions.format
                    );
                }

                let onFocusIn = undefined;
                if (c.editorOptions.onFocusIn) onFocusIn = c.editorOptions.onFocusIn;
                c.editorOptions.onFocusIn = (e) => {
                    if (e && e.element) {
                        var input = e.element.querySelector("input");
                        if (input)
                            input.setAttribute(
                                "autocomplete",
                                "new-input-" + e.name ? e.name : new Date().getTime()
                            );
                    }

                    if (onFocusIn) {
                        onFocusIn(e);
                    }
                };

                if (c.validationRules && c.required) {
                    c.validationRules.push({
                        type: "required",
                        message: `${c.label.text} is required`,
                        validationMessageMode: "always",
                    });
                } else if (c.required) {
                    c.validationRules = [
                        {
                            type: "required",
                            message: `${c.label.text} is required`,
                            validationMessageMode: "always",
                        },
                    ];
                    // c.editorOptions.validationMessageMode = "always";
                }

                return c;
            }
        },
        getDecimalFormatFromHelper(format) {
            return getDecimalFormat(format).EditFormat;
        },

        focusOutOnEditors() {
            var el = document.querySelectorAll("div.dx-form");
            if (el && el.length > 0) {
                el.forEach((element) => {
                    var getFormInstance = Form.getInstance(element);
                    for (const key in getFormInstance.option().formData) {
                        if (getFormInstance.getEditor(key)) {
                            if (getFormInstance.getEditor(key).NAME === 'dxButton') return;
                            getFormInstance.getEditor(key).blur();
                        }
                    }
                });
            }
        }
    },
};
